module.exports = __webpack_public_path__ + "static/media/img-hero-section-en.ffe141e7.png";